export enum TenantStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  SUSPENDED = 'suspended',
  CREATING = 'creating',
  DELETING = 'deleting',
  /** Soft-deleted community — hidden from public traffic; infra retained until permanent delete. */
  DELETED = 'deleted',
}
